import {
  Button,
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import usePrintingTable from "./usePrintingTable";
import ShowForm from "../ShowForm";
import BulkPass from "../BulkPass";
import { Table } from "../../../Global/Table";

const PrintingTable = ({
  gliNumber,
  visitingOneFrontPrintRef,
  visitingOneBackPrintRef,
  papperFrontPrintRef,
  papperBackPrintRef,
  bigFrontPrintRef,
  foldableCardRef,
  vistingDuplexRef,
  papperDuplexRef,
}) => {
  const {
    state,
    tableData,
    tableFields,
    isLoading,
    isFetching,
    paginationOptions,
    currentPageSize,
    previousPrintLoading,
    getRow,
    handleBulkPass,
    handleSearch,
    handlePageSize,
    handleEditClick,
    handlePagination,
    handlePrintClick,
    handlePreviousPrint,
  } = usePrintingTable({
    visitingOneFrontPrintRef,
    visitingOneBackPrintRef,
    papperFrontPrintRef,
    papperBackPrintRef,
    bigFrontPrintRef,
    foldableCardRef,
    vistingDuplexRef,
    papperDuplexRef,
  });

  return (
    <div>
      <h6 className="pro-ttl h6">{gliNumber}</h6>
      {!state?.isEdit && (
        <div className="pro-d-flex">
          <SearchFilters
            onSearchInput={handleSearch}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            showClearFilters={false}
            searchInputProps={{
              value: state?.search,
              placeholder: "Search Certificate Number",
            }}
            showActions={false}
            loading={isLoading}
          />
          <Button
            className={"pro-btn-primary"}
            type="button"
            onClick={handleBulkPass}
          >
            Bulk Pass
          </Button>
        </div>
      )}

      {state?.showForm ? (
        <ShowForm />
      ) : (
        <Table
          multiSelect={true}
          data={tableData?.data?.data ?? []}
          uniqueID={"id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          assignIcon={<span className="material-symbols-outlined">print</span>}
          editIcon={<span className="material-symbols-outlined">print</span>}
          getRow={getRow}
          loading={isFetching}
          perpage={currentPageSize}
          assignable={Boolean(tableData?.data?.printing_permission)}
          deletable={true}
          showCheckBox={true}
          editable={true}
          handleEdit={previousPrintLoading ? () => {} : handlePreviousPrint}
          handleAssign={handlePrintClick}
          assignText={`Print`}
          editText={previousPrintLoading ? `Preparing...` : `Download JPG`}
          clear={state.clear}
          deleteIcon={<span className="material-symbols-outlined">edit</span>}
          handleDelete={handleEditClick}
          deleteText={"Edit"}
        />
      )}
      {tableData?.data?.data && !state?.showForm && (
        <Pagination
          currentPage={state?.currentReissuePage}
          defaultValue={paginationOptions?.find(
            (item) => item?.value === state?.currentReissuePageSize,
          )}
          totalPageCount={Math.ceil(
            tableData?.data?.total_count / tableData?.data?.per_page,
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}
      <ModalLayout
        title={"Bulk Pass"}
        show={state.bulkPassModal}
        handleClose={handleBulkPass}
        closeIcon={<span className="material-symbols-outlined">close</span>}
      >
        <BulkPass />
      </ModalLayout>
    </div>
  );
};

export default PrintingTable;
